export default __webpack_public_path__ + "static/media/la_ferte-vidame08.d8119691.jpg";